import { AfterViewInit, Directive, EventEmitter, Input, NgZone, OnDestroy, Output, Self } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { fromEvent, Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[appMat3SelectInfiniteScroll]',
  standalone: true,
})
export class Mat3SelectInfiniteScrollDirective implements OnDestroy, AfterViewInit {
  @Input() debounceTime = 100;
  @Input() loading = false;
  @Input() disableInfinite = false;
  @Output() scrolled = new EventEmitter<void>();

  // eslint-disable-next-line @typescript-eslint/naming-convention
  private panel!: HTMLElement;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  private destroyed$ = new Subject<boolean>();

  constructor(@Self() private matSelect: MatSelect, private ngZone: NgZone) {
  }

  ngAfterViewInit(): void {
    if (!this.disableInfinite) {
      this.matSelect.openedChange.pipe(
        takeUntil(this.destroyed$),
      ).subscribe((opened) => {
        if (opened) {
          this.panel = this.matSelect.panel.nativeElement;
          this.registerScrollListener();
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  registerScrollListener(): void {
    fromEvent(this.panel, 'scroll').pipe(
      debounceTime(this.debounceTime),
      takeUntil(this.destroyed$),
    ).subscribe(event => {
      this.handleScrollEvent(event);
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  handleScrollEvent(event: unknown): void {
    this.ngZone.runOutsideAngular(() => {
      if (this.loading) {
        return;
      }

      if (this.panel.scrollHeight - this.panel.scrollTop - 100 <= this.panel.offsetHeight) {
        this.scrolled.emit();
      }
    });
  }

}
